<template>
    <div class="message-centre-page page">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" id="page_title">Companies</h4>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <div class="d-flex justify-content-between">
                <button @click="goTo(Routes.create_company)"
                        class="btn btn-primary waves-effect waves-light"
                        type="button">
                    <i class="mdi mdi-plus"/>
                    Create New Company
                </button>
                <div class="d-flex ml-4 ml-md-0 flex-column flex-md-row align-items-start align-items-md-center">
                    <p class="m-0 pr-2 listings-only-title">Show Suspended</p>
                    <input
                        @click="onShowSuspendedToggle"
                        checked
                        id="switch1"
                        switch="none"
                        type="checkbox"
                        v-model="filters.show_suspended"
                    />
                    <label
                        class="m-0"
                        data-off-label="No"
                        data-on-label="Yes"
                        for="switch1"
                    />
                </div>
            </div>
            <div class="mt-4">
                <div class="table-responsive">
                    <table class="table table-hover mb-0">
                        <thead>
                        <tr>
                            <th/>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Phone Number</th>
                            <th>Address</th>
                            <th>Status</th>
                            <th :width="155">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="!companies.data.length && companies.meta.fetched">
                            <td :colspan="6">
                                <p class="text-center">No data...</p>
                            </td>
                        </tr>
                        <tr v-if="companies.meta.loading">
                            <td :colspan="6">
                                <p class="text-center">Loading...</p>
                            </td>
                        </tr>
                        <tr v-for="company in companies.data">
                            <td>
                                <img :src="company.logo ? company.logo : '/images/user-4.jpg'"
                                     class="d-flex mr-3 rounded-circle logo-image"
                                     height="30">
                            </td>
                            <td>{{ company.name }}</td>
                            <td>{{ company.email }}</td>
                            <td>{{ company.phone_number }}</td>
                            <td>{{ company.address }}</td>
                            <td>
                                <span v-if="!company.deleted_at">
                                    <i class="mdi mdi-checkbox-blank-circle text-success"/>
                                    Active
                                </span>
                                <span v-else>
                                    <i class="mdi mdi-checkbox-blank-circle text-danger"/>
                                    Suspended
                                </span>
                            </td>
                            <td>
                                <button @click="goTo(Routes.company_users, {
                                            company_id: company.id
                                        })"
                                        :disabled="busy"
                                        class="btn btn-outline-info waves-effect waves-light"
                                        type="button"
                                >
                                    <i class="mdi mdi-account-multiple"/>
                                </button>
                                <button @click="goTo(Routes.view_company, {
                                            id: company.id
                                        })"
                                        :disabled="busy"
                                        class="btn btn-info waves-effect waves-light"
                                        type="button"
                                >
                                    <i class="mdi mdi-pencil"/>
                                </button>
                                <button :disabled="busy"
                                        @click="restoreCompany(company)"
                                        class="btn btn-success waves-effect waves-light"
                                        type="button"
                                        v-if="company.deleted_at">
                                    <i class="mdi mdi-check"/>
                                </button>
                                <button :disabled="busy"
                                        @click="deleteCompany(company)"
                                        class="btn btn-danger waves-effect waves-light"
                                        type="button"
                                        v-else>
                                    <i class="mdi mdi-cancel"/>
                                </button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <pagination :pagination="companies.meta.pagination"
                                @current-change="onChangePage"
                                class="pt-2"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Routes from "@/constants/routes";
    import Company from "@/models/company";

    export default {
        data() {
            return {
                Routes,
                companies: {
                    data: [],
                    meta: {
                        fetched: false,
                        loading: false,
                        pagination: null
                    }
                },
                filters: {
                    show_suspended: false,
                },
                busy: false
            }
        },
        mounted() {
            this.initFilters(this.$route);
            this.initCompanies();
        },
        methods: {
            initFilters(route) {
                this.filters.show_suspended = parseInt(route.query.show_suspended) === 1;
            },
            fetchCompanies(page) {
                this.companies.meta.loading = true;
                let company = Company
                    .params({
                        filter: {
                            show_suspended: this.filters.show_suspended
                        }
                    });
                if (page) {
                    company = company.page(page);
                }

                return company.get();
            },
            initCompanies(page) {
                this.fetchCompanies(page)
                    .then((response) => {
                        this.companies.data = response.data;
                        this.companies.meta.fetched = true;
                        this.companies.meta.loading = false;
                        this.companies.meta.pagination = response.meta;
                    });
            },
            restoreCompany(company) {
                this.$confirm('Are you sure to restore this company?', 'Confirm', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.busy = true;
                    Company.restore(company.id)
                        .then(() => {
                            let deleted_company = _.find(this.companies.data, {id: company.id});
                            if (deleted_company) {
                                deleted_company.deleted_at = null;
                            }
                            this.$notify({
                                title: 'Success',
                                message: 'Successfully restored company.',
                                type: 'success'
                            });
                        })
                        .finally(() => {
                            this.busy = false;
                            this.initCompanies();
                        })
                });
            },
            deleteCompany(company) {
                this.$confirm('Are you sure to suspend this company?', 'Confirm', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.busy = true;
                    Company.delete(company.id)
                        .then(() => {
                            let deleted_company = _.find(this.companies.data, {id: company.id});
                            if (deleted_company) {
                                deleted_company.deleted_at = new Date();
                            }
                            this.$notify({
                                title: 'Success',
                                message: 'Successfully suspended company.',
                                type: 'success'
                            });
                        })
                        .finally(() => {
                            this.busy = false;
                            this.initCompanies();
                        })
                });
            },
            onChangePage(page) {
                this.initCompanies(page)
            },
            goTo(route_name, params = {}) {
                this.$router.push({
                    name: route_name,
                    params
                })
            },
            onShowSuspendedToggle() {
                this.filters.show_suspended = !this.filters.show_suspended;
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        show_suspended: this.filters.show_suspended ? 1 : 0
                    }
                }).then(() => {
                    this.initCompanies();
                });
            },
        }
    }
</script>

<style scoped>
    .logo-image {
        width: 30px;
        height: 30px;
        object-fit: cover;
        cursor: pointer;
    }
</style>
